import { AppError, extractMessage } from '@/helpers'

export class VoteError extends AppError {
  constructor(options: { userMessage?: string; originalError?: unknown }) {
    super({
      title: 'Vote failed',
      userMessage: options.userMessage,
      originalError: options.originalError,
      context: 'vote',
    })
    this.name = 'VoteError'
  }

  static fromUnknown(error: unknown): VoteError {
    const raw = extractMessage(error)
    const lower = raw.toLowerCase()

    if (lower.includes('proposal not found')) {
      return new VoteError({
        userMessage: 'Proposal not found',
        originalError: error,
      })
    }

    if (lower.includes('inactive proposal')) {
      return new VoteError({
        userMessage: 'Proposal is not active for voting',
        originalError: error,
      })
    }

    if (lower.includes('invalid vote option')) {
      return new VoteError({
        userMessage: 'Invalid vote option',
        originalError: error,
      })
    }

    if (lower.includes('insufficient funds')) {
      return new VoteError({
        userMessage: 'Insufficient funds to cover fees',
        originalError: error,
      })
    }

    return new VoteError({
      userMessage: raw || undefined,
      originalError: error,
    })
  }
}
